const PROMPT_PLACEHOLDER_RE = /\{[a-z_][a-z0-9_]*\}/i;

const pickText = (value) => {
    if (value == null) return '';
    const s = String(value).trim();
    return s;
};

/** 判断是否为下发给模型的 prompt 模板，而非用户真实输入 */
export const isPromptTemplateText = (text) => {
    const t = pickText(text);
    if (!t) return false;

    const hasKnowledgeBlock = /Available Knowledge Sources/i.test(t);
    const hasQuestionBlock = /Current User Question/i.test(t);
    if (hasKnowledgeBlock && hasQuestionBlock) return true;

    const hasKnownPlaceholder =
        t.includes('knowledge_context') ||
        t.includes('session_history') ||
        t.includes('session_count');
    return hasKnownPlaceholder && PROMPT_PLACEHOLDER_RE.test(t);
};

const normalizeExtractedQuery = (raw) => {
    let query = pickText(raw);
    if (!query) return '';
    query = query.replace(/^\{?\s*query\s*\}?\s*$/i, '').trim();
    if (!query || PROMPT_PLACEHOLDER_RE.test(query)) return '';
    return query;
};

/** 从 prompt 模板中提取「Current User Question」段落 */
export const extractQueryFromPromptTemplate = (text) => {
    const t = String(text || '');
    if (!t) return '';

    const headerLineMatch = t.match(/#\s*Current User Question\s*(.*)$/im);
    if (headerLineMatch?.[1]) {
        const fromHeaderLine = normalizeExtractedQuery(headerLineMatch[1]);
        if (fromHeaderLine) return fromHeaderLine;
    }

    const sectionMatch = t.match(
        /#\s*Current User Question[^\n]*\n+([\s\S]*?)(?=\n\s*#\s+|\s*$)/i
    );
    if (sectionMatch?.[1]) {
        const fromSection = normalizeExtractedQuery(sectionMatch[1]);
        if (fromSection) return fromSection;
    }

    const inlineMatch = t.match(/Current User Question\s*[:\-]?\s*(.+)$/im);
    if (inlineMatch?.[1]) {
        const fromInline = normalizeExtractedQuery(inlineMatch[1]);
        if (fromInline && !isPromptTemplateText(fromInline)) {
            return fromInline;
        }
    }

    return '';
};

const parseChatParamMessage = (chatParam) => {
    if (!chatParam) return '';
    if (typeof chatParam === 'object' && chatParam !== null) {
        return pickText(chatParam.message);
    }
    if (typeof chatParam === 'string') {
        try {
            const parsed = JSON.parse(chatParam);
            return pickText(parsed?.message);
        } catch {
            return '';
        }
    }
    return '';
};

/**
 * 解析 /chat/history 单条记录中应展示的用户消息文案
 */
export const resolveHistoryUserContent = (item) => {
    if (!item || typeof item !== 'object') return '';

    const fieldCandidates = [
        item.query,
        item.user_query,
        item.original_user_content,
        item.original_message,
        item.user_message,
        item.message,
        item.input,
        parseChatParamMessage(item.chat_param),
    ];

    for (let i = 0; i < fieldCandidates.length; i += 1) {
        const value = pickText(fieldCandidates[i]);
        if (value && !isPromptTemplateText(value)) {
            return value;
        }
    }

    const raw = pickText(item.user_content);
    if (!raw) {
        return pickText(item.ai_extracted_content);
    }
    if (!isPromptTemplateText(raw)) {
        return raw;
    }

    const extracted = extractQueryFromPromptTemplate(raw);
    if (extracted) return extracted;

    const aiExtracted = pickText(item.ai_extracted_content);
    if (aiExtracted && !isPromptTemplateText(aiExtracted)) {
        return aiExtracted;
    }

    return '';
};
